import React from 'react';
import { Form, Input, Button } from 'antd';
import { UploadImage } from '../Form/UploadImage';
import { PatternFormat } from 'react-number-format';
import { PlanOwnerFormProps } from '../../types/planOwner';

export const PlanOwnerForm: React.FC<PlanOwnerFormProps> = ({
  form,
  initialValues,
  onFinish,
  loading = false,
  submitText = 'Submit',
}) => {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      initialValues={{
        name: '',
        ceo: '',
        phone: '',
        email: '',
        webSite: '',
        about: '',
        logo: [],
        photos: [],
        ...initialValues,
      }}>
      <Form.Item
        name="name"
        label="Company Name"
        rules={[{ required: true, message: 'Please enter company name' }]}>
        <Input placeholder="Enter company name" />
      </Form.Item>

      <Form.Item name="ceo" label="CEO">
        <Input placeholder="Enter CEO name" />
      </Form.Item>

      <Form.Item
        name="phone"
        label="Phone"
        rules={[
          {
            pattern: /^\(\d{3}\) \d{3}-\d{4}$/,
            message: 'Please enter a valid US phone number',
          },
        ]}>
        <PatternFormat
          customInput={Input}
          format="(###) ###-####"
          mask="_"
          placeholder="(555) 555-5555"
        />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please enter email' },
          { type: 'email', message: 'Please enter a valid email' },
        ]}>
        <Input placeholder="Enter email" />
      </Form.Item>

      <Form.Item
        name="webSite"
        label="Website"
        rules={[{ type: 'url', message: 'Please enter a valid URL' }]}>
        <Input placeholder="Enter website URL" />
      </Form.Item>

      <Form.Item name="about" label="About">
        <Input.TextArea rows={4} placeholder="Enter description" />
      </Form.Item>

      <Form.Item name="logo" label="Logo">
        <UploadImage maxCount={1} />
      </Form.Item>

      <Form.Item name="photos" label="Photos">
        <UploadImage maxCount={10} multiple={true} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};
